import * as yup from 'yup';
import { useI18n } from "vue-i18n";
import { i18n } from '@/i18n' 

const schemaEmail = () => {
    const t = i18n.global.t;
    return yup.object({
        email: yup.string().required(t('warning.REQUIRED_MESSAGE')).email('Invalid email format'),
    });
};

const schemaPhonePassword = () => {
    const t = i18n.global.t;
    return yup.object({
        phone: yup.string().required(t('warning.REQUIRED_MESSAGE')),
        password: yup.string().required(t('warning.REQUIRED_MESSAGE')),
    });
};

const schemaEmailPassword = () => {
    const t = i18n.global.t;
    return yup.object({
        email: yup.string().required(t('warning.REQUIRED_MESSAGE')).email('Invalid email format'),
        password: yup.string().required(t('warning.REQUIRED_MESSAGE')),
    });
};

const schemaPhone = () => {
    const t = i18n.global.t;
    return yup.object({
        phone: yup.string().required(t('warning.REQUIRED_MESSAGE')),
    });
};

const schemaCode = () => {
    const t = i18n.global.t;
    return yup.object({
        code: yup.string().required(t('warning.REQUIRED_MESSAGE')),
    });
};

const schemaPassword = () => {
    const t = i18n.global.t;
    return yup.object({
        username: yup.string().required(t('warning.REQUIRED_MESSAGE')),
        password: yup.string().required(t('warning.REQUIRED_MESSAGE')),
    });
};

const reportPublicationSchema = () => {
    const t = i18n.global.t;
    return yup.object({
        content: yup.string(),
        report_type: yup.string().required(t('warning.REQUIRED_MESSAGE')),
        terms: yup.string().required(t('warning.REQUIRED_MESSAGE'))
    });
};

const commentSchema = () => {
    const t = i18n.global.t;
    return yup.object({
        content: yup.string().required(t('warning.REQUIRED_MESSAGE')),
        terms: yup.string().required(t('warning.REQUIRED_MESSAGE'))
    });
};

const checkoutSchema = () => {
    const t = i18n.global.t;
    return yup.object({
        name: yup.string().required(t('warning.REQUIRED_MESSAGE')),
        phone: yup.string().required(t('warning.REQUIRED_MESSAGE')),
        address: yup.string().required(t('warning.REQUIRED_MESSAGE')),
        payment_method: yup.number().required(t('warning.REQUIRED_MESSAGE')),
        delivery_type: yup.number().required(t('warning.REQUIRED_MESSAGE')),
    });
};

const addressSchema = () => {
    const t = i18n.global.t;
    return yup.object({
        name: yup.string().required(t('warning.REQUIRED_MESSAGE')),
        phone: yup.string().required(t('warning.REQUIRED_MESSAGE')),
        address: yup.string().required(t('warning.REQUIRED_MESSAGE')),
    });
};

const schemaService = () => {
    const t = i18n.global.t;
    return yup.object({
        quantity: yup.number().required(t('warning.REQUIRED_MESSAGE')),
        bank: yup.number().required(t('warning.REQUIRED_MESSAGE')),
    });
};

const passwordResetSchema = () => {
    const t = i18n.global.t;
    return yup.object({
        newPassword: yup
            .string()
            .required(t('warning.NEW_PASSWORD_REQUIRED_MESSAGE'))
            .min(8, t('warning.NEW_PASSWORD_VALIDATION_MESSAGE')),
        confirmPassword: yup
            .string()
            .required(t('warning.NEW_PASSWORD_CONFIRM_MESSAGE'))
            .oneOf([yup.ref('newPassword'), null], t('warning.NEW_PASSWORD_MATCH_MESSAGE')),
    });
};
const passwordResetModalSchema = () => {
    const t = i18n.global.t;
    return yup.object({
        username: yup.string().required(t('warning.REQUIRED_MESSAGE')),
        password: yup
            .string()
            .required(t('warning.NEW_PASSWORD_REQUIRED_MESSAGE'))
            .min(8, t('warning.NEW_PASSWORD_VALIDATION_MESSAGE')),
        confirmPassword: yup
            .string()
            .required(t('warning.NEW_PASSWORD_CONFIRM_MESSAGE'))
            .oneOf([yup.ref('password'), null], t('warning.NEW_PASSWORD_MATCH_MESSAGE')),
    });
};

export { 
    schemaPhonePassword, 
    schemaEmailPassword, 
    schemaPhone, 
    schemaCode, 
    schemaEmail, 
    schemaPassword, 
    reportPublicationSchema, 
    checkoutSchema, 
    commentSchema, 
    addressSchema, 
    schemaService, 
    passwordResetSchema,
    passwordResetModalSchema
};
